import TimePickerComponent from '../components/TimePicker';
import {
  TextAreaComponent,
  DefaultTextComponent,
  SelectComponent,
  ButtonComponent,
  CheckboxComponent,
} from '../components/InputsComponents';

import { isEqual } from 'lodash';
import axios from 'axios';
import collections from '../../../constants/FirestoreCollections';

const apiUrl = process.env.REACT_APP_MESSAGES_URL;
const apiCustomMessageUrl = '/v1/';

export const createNewMessageFetch = async (token, body, infoRoute) => {
  let requestOptions;
  const url = apiUrl + apiCustomMessageUrl + infoRoute;
  if (infoRoute === 'edit') {
    const messageId = body.id;
    delete body.id;
    requestOptions = {
      method: 'PATCH',
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      },
      data: JSON.stringify({ messageUpdates: body, messageId }),
    };
  } else if (infoRoute === 'add') {
    requestOptions = {
      method: 'POST',
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      },
      data: JSON.stringify({ newMessage: body }),
    };
  } else if (infoRoute === 'delete') {
    const messageId = body.id;
    delete body.id;
    requestOptions = {
      method: 'DELETE',
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      },
      data: JSON.stringify({ messageId }),
    };
  }

  try {
    const response = await axios(url, requestOptions);
    return response.data || response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const generateInputs = (structureForInputs, config, isAdmin, organization, onCreate) => {
  return structureForInputs(
    onCreate,
    [
      ...(config &&
        config.states &&
        config.states
          .filter(
            (state) =>
              organization && organization.states && organization.states.includes(state.key),
          )
          .map((state) => ({
            value: parseInt(state.key),
            label: state.label,
          }))),
      { value: 3, label: 'terminado' },
    ] || [],
    isAdmin,
  );
};

export const getInputs = (input, index, setLastFocus, setTmpMessage, tmpMessage, classes, i) => {
  switch (input.type) {
    case 'textarea':
      return (
        <TextAreaComponent
          input={input}
          index={index}
          setLastFocus={setLastFocus}
          setTmpMessage={setTmpMessage}
          tmpMessage={tmpMessage}
          classes={classes}
          key={i}
        />
      );
    case 'text':
    default:
      return (
        <DefaultTextComponent
          input={input}
          setLastFocus={setLastFocus}
          setTmpMessage={setTmpMessage}
          tmpMessage={tmpMessage}
          key={i}
        />
      );
  }
};

export const getOtherInputs = (
  input,
  index,
  tmpMessage,
  setTmpMessage,
  handleSuccess,
  handleDanger,
  classes,
  initialState,
  i,
) => {
  switch (input.type) {
    case 'select':
      return (
        <SelectComponent
          input={input}
          index={index}
          setTmpMessage={setTmpMessage}
          tmpMessage={tmpMessage}
          key={i}
        />
      );
    case 'button': {
      if (isEqual(tmpMessage, initialState) && input.isSuccess) return null;
      else
        return (
          <ButtonComponent
            input={input}
            index={index}
            handleSuccess={handleSuccess}
            handleDanger={handleDanger}
            classes={classes}
            key={i}
          />
        );
    }

    case 'checkbox':
      return (
        <CheckboxComponent
          input={input}
          index={index}
          setTmpMessage={setTmpMessage}
          tmpMessage={tmpMessage}
          key={i}
        />
      );
    case 'timePicker': {
      return (
        <TimePickerComponent
          setTmpMessage={setTmpMessage}
          tmpMessage={tmpMessage}
          input={input}
          index={index}
          classes={classes}
          key={i}
        />
      );
    }
  }
};

export const updateFirestoreData = async (docId, updateData, firestore) => {
  try {
    return firestore.collection(collections.organizations).doc(docId).update(updateData);
  } catch (error) {
    console.error('updateFirestoreData', error);
    throw error;
  }
};

export const validateIOSPWANotifications = () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isInStandaloneMode =
    window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

  if (isIOS && !isInStandaloneMode) {
    console.warn(
      '⚠️ Las notificaciones push en iOS solo funcionan desde una PWA instalada en pantalla de inicio.',
    );
    return false;
  }
  return true;
};
